import { isBefore, isSameDay } from "date-fns";
import { last } from "lodash";

import { IClassroomResource } from "@sol/sdk";

export function lastStartedClassroom<T extends IClassroomResource>(classrooms: T[] = [], date: Date) {
    // We filter started or finished classrooms.
    const startedClassrooms = classrooms.filter(
        c => isBefore(new Date(c.startDate), date) || isSameDay(new Date(c.startDate), date),
    );

    // We sort them from oldest start date to newest start date.
    startedClassrooms.sort((c1, c2) => {
        return new Date(c1.startDate).getTime() - new Date(c2.startDate).getTime();
    });

    // As classrooms dates cannot overlap the latest one is the one that was just finished or the current one.
    return last(startedClassrooms);
}
